const zh = {
  //header
  'home': '首页',
  'about': '关于我们',
  'product': '产品展示',
  'use': '使用指南',
  'news': '新闻资讯',
  'contact': '联系我们',

  //首页
  'index1':'查看更多',
  'index2':'为什么选择我们',
  'index3':'您的位置',

  //关于我们
  'about1':'公司简介',
  'about2':'我们的优势',
  'about3':'企业荣誉',
  'about4':'车间展示',
  'about5':'我们的',
  'about6':'优势',

  //产品
  'product1':'产品详情',
  'product2':'热门产品',

  //新闻
  'news1':'查看详情',
  'news2':'资讯详情',
  'news3':'上一篇',
  'news4':'下一篇',
  'news5':'来源',
  'news6':'发表时间',



  //联系
  'con1':'您的姓名',
  'con2':'您的电话',
  'con3':'您的邮箱',
  'con4':'您的地址',
  'con5':'留言',
  'con6':'提交',
  'con7':'联系地址',
  'con8':'专属电话',
  'con9':'商务邮箱',
  'con10':'在线留言',


  //侧边
  'aside1':'电话',
  'aside2':'邮箱',
  'aside3':'微信',
  'aside4':'通过微信与我们的客服直接对话',
  'aside5':'扫描二维码联系我们',

  //底部
  'foot1':'官方公众号',
  'foot2':'技术支持',
  'foot3':'超易平科技有限公司版权所有',
  'foot4':'科辉荣盛',
  



}
export default zh;
